import { QuizResponse } from "@platform/types/quiz.types";
import { makeQuizQuestionInputKey } from "./makeQuizQuestionInputKey";

export function packFormDefaultValuesFromQuiz(quiz: QuizResponse) {
  if (!quiz || !quiz.questions) return {};

  return (
    quiz.questions
      // only include answered questions
      .filter((q) => q.answered)

      // clean up old user_answer format (used to be strings before converted to ids)
      .map((q) => ({
        ...q,
        user_answer: q.user_answer?.filter(
          (answer) => typeof answer === "number"
        ),
      }))

      // map to form field name and value [ { "question-1" : "answer" }, { "question-2" : "answer" } ]
      .map((q) => ({
        [makeQuizQuestionInputKey(q.id)]:
          q.type === "text input" ? q.user_answer_text : q.user_answer,
      }))

      // reduce to object { "question-1" : "answer", "question-2" : "answer" }
      .reduce((acc, obj) => {
        const [key, value] = Object.entries(obj)[0];
        acc[key] = value;
        return acc;
      }, {})
  );
}

export default packFormDefaultValuesFromQuiz;
